// @ts-nocheck
import { get } from 'lodash'
import dayjs from 'dayjs'
import { colors } from '@lmc/common/constants'
import theme from '../../../LEGACY/theme'
import DateField from './DateField'

export default function BirthdateField(props) {
  const { formKey, values, disabled } = props
  const value = get(values, formKey)
  const age = dayjs().diff(dayjs(value, 'DD-MM-YYYY'), 'years')
  const displayAge = isNaN(parseInt(age)) ? 0 : age
  return (
    <DateField {...props} disabled={disabled}>
      {value && (
        <div style={localStyles.ageWrapper} className="age-value">
          <div style={localStyles.ageText}>Age</div>
          <div
            style={{
              ...localStyles.ageValue,
              ...(disabled && localStyles.disabled),
            }}
          >
            {displayAge}
          </div>
        </div>
      )}
    </DateField>
  )
}

const localStyles = {
  ageWrapper: {
    display: 'flex',
    flex: 1,
    marginRight: 15,
  },
  ageText: {
    paddingTop: 7,
  },
  ageValue: {
    background: colors.grey,
    borderRadius: 5,
    fontWeight: 600,
    height: theme.input.height,
    marginLeft: 5,
    padding: '7px 10px 0px 10px',
  },
  disabled: {
    opacity: 0.39,
  },
}
